export default "__VITE_ASSET__693fdbc7__"